export const getSubjectType = (subject = "") => {
  if (subject.includes("Intervention")) {
    return "interventions";
  } else if (subject.includes("Asset")) {
    return "assets";
  } else if (subject.includes("Location")) {
    return "locations";
  } else if (subject.includes("Organization")) {
    return "organizations";
  } else {
    return null; // SuperAdmin
  }
};
